import React, { useState } from 'react';

const AdminUserImport = () => {
  const [users, setUsers] = useState([{ firstName: '', lastName: '', email: '', jobTitle: '', organization: '', group: '' }]);
  const [status, setStatus] = useState({ success: null, message: '' });
  const [planType, setPlanType] = useState('paid');
  const [plan, setPlan] = useState('paid');

  const handleChange = (index, field, value) => {
    const updatedUsers = [...users];
    updatedUsers[index][field] = value;
    setUsers(updatedUsers);
  };

  const addRow = () => {
    setUsers([...users, { firstName: '', lastName: '', email: '', jobTitle: '', organization: '', group: '' }]);
  };

  const removeRow = (index) => {
    if (users.length === 1) return;
    const updatedUsers = users.filter((_, i) => i !== index);
    setUsers(updatedUsers);
  };

  const handleSubmit = async () => {
    setStatus({ success: null, message: '' });

    const hasErrors = users.some(user =>
      !user.firstName.trim() || !user.lastName.trim() || !user.email.trim()
    );

    if (hasErrors) {
      setStatus({ success: false, message: 'Please complete all fields before submitting.' });
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/create-users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
            plan,
            planType,
            users
          })
      });

      if (!response.ok) throw new Error('Failed to create users');

      const data = await response.json();
      setStatus({ success: true, message: `Successfully created ${data.createdCount} user(s).` });
      setUsers([{ firstName: '', lastName: '', email: '' }]);
    } catch (err) {
      console.error(err);
      setStatus({ success: false, message: 'Error creating users. Please try again.' });
    }
  };

  return (
    <div className="p-6 bg-white min-h-screen">
        <h1 className="text-2xl font-bold mb-4">Import New Users</h1>

        <div className="flex flex-auto gap-8">
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Plan</label>
                <select
                    value={plan}
                    onChange={(e) => setPlan(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                >
                    <option value="paid">Paid</option>
                    <option value="free">Free</option>
                </select>
            </div>

            <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Plan Type</label>
                <select
                    value={planType}
                    onChange={(e) => setPlanType(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                >
                    <option value="free">Free</option>
                    <option value="monthly">Monthly</option>
                    <option value="annual">Annual</option>
                    <option value="enterprise">Enterprise</option>
                </select>
            </div>
        </div>

        {status.message && (
            <div className={`mb-4 p-3 rounded ${status.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {status.message}
            </div>
        )}

        <div className="grid grid-cols-7 gap-4 mb-2 font-semibold text-gray-700">
            <div>First Name</div>
            <div>Last Name</div>
            <div>Email</div>
            <div>Job Title</div>
            <div>Organization</div>
            <div>Group</div>
            <div></div>
        </div>

        {users.map((user, index) => (
            <div key={index} className="grid grid-cols-7 gap-4 mb-3">
                <input
                    type="text"
                    value={user.firstName}
                    onChange={(e) => handleChange(index, 'firstName', e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                    placeholder="First Name"
                />
                <input
                    type="text"
                    value={user.lastName}
                    onChange={(e) => handleChange(index, 'lastName', e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                    placeholder="Last Name"
                />
                <input
                    type="email"
                    value={user.email}
                    onChange={(e) => handleChange(index, 'email', e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                    placeholder="Email"
                />
                <input
                    type="text"
                    value={user.jobTitle}
                    onChange={(e) => handleChange(index, 'jobTitle', e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                    placeholder="Job Title"
                />
                <input
                    type="text"
                    value={user.organization}
                    onChange={(e) => handleChange(index, 'organization', e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2"
                    placeholder="Organization"
                />
                <input
                  type="text"
                  value={user.group}
                  onChange={(e) => handleChange(index, 'group', e.target.value)}
                  className="border border-gray-300 rounded px-3 py-2"
                  placeholder="Group"
                />
                <button
                    onClick={() => removeRow(index)}
                    disabled={users.length === 1}
                    className={`text-red-500 font-semibold hover:underline disabled:text-gray-300`}
                >
                    Remove
                </button>
            </div>
        ))}

        <div className="flex gap-4 mt-6">
            <button
                onClick={addRow}
                className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold px-4 py-2 rounded"
                >
                + Add Row
            </button>
            <button
                onClick={handleSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded"
                >
                Submit All
            </button>
        </div>
    </div>
  );
};

export default AdminUserImport;
